import {Component, Input, OnInit} from '@angular/core';
import {Button} from '../../../shared/button/button.component';
import {ButtonDispensingJugsPremiumInterface, ButtonsPremiumState} from '../../../interfaces/simulator-premium';

@Component({
  selector: 'app-button-jugs-premium',
  templateUrl: './button-jugs-premium.component.html',
  styleUrls: ['./button-jugs-premium.component.sass']
})
export class ButtonJugsPremiumComponent extends Button implements OnInit {

  @Input() data: ButtonDispensingJugsPremiumInterface;
  public state: any;

  constructor() {
    super();
    this.state = ButtonsPremiumState;
  }

  ngOnInit() {
  }

}
